<template>
  <div class="fullheight flex vertical centered absolute bgd o9 keepOnTop">
    <div class="tc fullwidth">
      <ion-spinner name="dots" color="primary"></ion-spinner>
      <div class="fs cp boldFont uppercase"><slot></slot></div>
    </div>
    <div></div>
  </div>
</template>
